/**
 * @generated SignedSource<<1abb4d319e89d9f765979fe6dc6822c5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type AIStudioTaskState = "COMPLETED" | "ERROR" | "PROCESSING" | "WAITING";
export type tasksVideoGenerationTaskStatusQuery$variables = {
  taskId: number;
};
export type tasksVideoGenerationTaskStatusQuery$data = {
  readonly videoGenerationTaskStatus: {
    readonly completedAt: string | null;
    readonly createdAt: string;
    readonly errorMessage: string | null;
    readonly processingTimeMs: number | null;
    readonly resultUrl: string | null;
    readonly state: AIStudioTaskState;
    readonly taskId: number;
  } | null;
};
export type tasksVideoGenerationTaskStatusQuery = {
  response: tasksVideoGenerationTaskStatusQuery$data;
  variables: tasksVideoGenerationTaskStatusQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "taskId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "taskId",
        "variableName": "taskId"
      }
    ],
    "concreteType": "VideoGenerationTaskStatus",
    "kind": "LinkedField",
    "name": "videoGenerationTaskStatus",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "taskId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "state",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "resultUrl",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "errorMessage",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "processingTimeMs",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "createdAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "completedAt",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "tasksVideoGenerationTaskStatusQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "tasksVideoGenerationTaskStatusQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "7fd7f1af6a8bf9a0d4a27bdcd1055cb3",
    "id": null,
    "metadata": {},
    "name": "tasksVideoGenerationTaskStatusQuery",
    "operationKind": "query",
    "text": "query tasksVideoGenerationTaskStatusQuery(\n  $taskId: Long!\n) {\n  videoGenerationTaskStatus(taskId: $taskId) {\n    taskId\n    state\n    resultUrl\n    errorMessage\n    processingTimeMs\n    createdAt\n    completedAt\n  }\n}\n"
  }
};
})();

(node as any).hash = "2219ea82d1471597890f9da5bb599419";

export default node;
